export default "__VITE_ASSET__CYsjS7Kv__"